import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errDetail } from "@agent/lib/api";

/** Owns LinkedIn/website publisher status plus the publish + copy-for-LinkedIn actions. */
export function usePublishFlow(draft, setDraft) {
  const [publishOpen, setPublishOpen] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [liStatus, setLiStatus] = useState(null);
  const [webStatus, setWebStatus] = useState(null);

  useEffect(() => {
    api.get("/linkedin/status").then((r) => setLiStatus(r.data)).catch(() => {});
    api.get("/website/status").then((r) => setWebStatus(r.data)).catch(() => {});
    // Runs once on mount only; `api` is a stable module-level client.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const publish = async (channels) => {
    setPublishing(true);
    try {
      const { data } = await api.post(`/drafts/${draft.id}/publish`, { confirm: true, channels });
      setDraft({ ...draft, status: "published", linkedin_post_id: data.linkedin_post_id || draft.linkedin_post_id, blog_url: data.blog_url || draft.blog_url });
      setPublishOpen(false);
      const targets = [data.linkedin_post_id && "LinkedIn", data.blog_url && "website blog"].filter(Boolean).join(" + ");
      toast.success(`Published to ${targets} 🎉`);
    } catch (e) {
      toast.error(errDetail(e));
    } finally {
      setPublishing(false);
    }
  };

  const copyForLinkedin = async () => {
    try {
      await navigator.clipboard.writeText(draft.content);
      toast.success("Post text copied — paste it into LinkedIn");
    } catch (e) {
      toast.error("Couldn't copy automatically — select and copy the content box manually");
    }
  };

  return {
    publishOpen, setPublishOpen, publishing, liStatus, webStatus, publish, copyForLinkedin,
    linkedinReady: !!(liStatus?.connected && liStatus?.org_id),
    liConnected: !!liStatus?.connected,
    liHasOrgId: !!liStatus?.org_id,
    websiteReady: !!webStatus?.configured,
  };
}
